module.exports = __webpack_public_path__ + "staticcomp/img/top.97d0d16.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3/2/top.jpg
// module id = rZC0
// module chunks = 39